import React from "react";
import "./TrainingSlider.css";
import { Carousel } from "react-bootstrap";

const TrainingSlider = () => {
  return (
    <div className="container">
      <Carousel>
        <Carousel.Item>
          <div className="TrainingSlider">
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus dolorum.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Tikoh Amin</h6>
                  <small className="ps-2">Salon Owner</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus dolorum.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Malachi Lensing</h6>
                  <small className="ps-2">Marketing manager</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus dolorum.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Delbert Simonas</h6>
                  <small className="ps-2">Store Owner</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus dolorum.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Chirstian Isla</h6>
                  <small className="ps-2">Android Developer</small>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="TrainingSlider">
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Lori Charles</h6>
                  <small className="ps-2">Sales manager</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus dolorum .
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Tikoh Amin</h6>
                  <small className="ps-2">Salon Owner</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus .
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Malachi Lensing</h6>
                  <small className="ps-2">Marketing manager</small>
                </div>
              </div>
            </div>
            <div>
              <img
                style={{ height: "30px" }}
                className="my-2"
                src="https://img.icons8.com/ultraviolet/40/000000/quote-left.png"
                alt=""
              />
              <p className="fs-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum
                eius necessitatibus.
              </p>
              <hr />
              <div className="TrainingSlideImgInfo">
                <div>
                  <img
                    src="https://img.icons8.com/bubbles/100/000000/edit-user.png"
                    alt=""
                  />{" "}
                </div>
                <div>
                  <h6 className="pt-2">Chirstian Isla</h6>
                  <small className="ps-2">Android Developer</small>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default TrainingSlider;
